import AbstractSeriesSpecification from "./AbstractSeriesSpecification.js";
import KeyFigureFormulaNode from "../../keyFigure/formula/KeyFigureFormulaNode.js";
import KeyFigureValue from "../../keyFigure/value/KeyFigureValue.js";

/**
 * Concrete implementation of an {@link AbstractSeriesSpecification}
 * representing a computation request for a {@link KeyFigure}.
 *
 * @param {KeyFigure[]} keyFigures - List of all available keyFigures
 */
export default class KeyFigureSeriesSpecification extends AbstractSeriesSpecification {
	constructor({ keyFigure }) {
		super(...arguments);

		this._keyFigure = keyFigure;
	}

	getKeyFigureValues() {
		return this._values.map(
			(value) =>
				new KeyFigureValue({ component: this._keyFigure, value }),
		);
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(data, context);

		data.keyFigure = context.keyFigures.find(
			(kpi) => kpi.getId() === data.key.id,
		);
	}

	static makeNodeFromModel({ keyFigure }) {
		return new KeyFigureFormulaNode({ keyFigure });
	}

	static makeOperationTypeFromModel({ operationType, keyFigure, report }) {
		return operationType || report.getKeyFigureOperationType(keyFigure);
	}

	static getType() {
		return "KeyFigureSeriesSpecification";
	}

	static _makeKeyDataFromModel(data) {
		return {
			...super._makeKeyDataFromModel(data),
			id: data.keyFigure.getId(),
			operationType: this.makeOperationTypeFromModel(data),
		};
	}
}
